import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="history-search"
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.timeout = null
  }

  search(event) {
    // Clear any existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    
    // Set a new timeout to debounce the search
    this.timeout = setTimeout(() => {
      this.performSearch()
    }, 300)
  }

  performSearch() {
    // Submit the form automatically when user types
    const form = this.element.closest('form')
    if (form) {
      // Use Turbo to submit the form for AJAX behavior
      form.requestSubmit()
    }
  }

  disconnect() {
    // Clean up timeout when controller disconnects
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
